
import Vue from "vue";
import { IEvent } from "../store/state";

// Interfaces for component typechecking!
interface AmountHitsShowingData {}

interface AmountHitsShowingMethods {}

interface AmountHitsShowingComputed {
  amountShowing: number;
  totalItems: number;
}

interface AmountHitsShowingProps {
  event: IEvent;
}

export default Vue.extend<
  AmountHitsShowingData,
  AmountHitsShowingMethods,
  AmountHitsShowingComputed,
  AmountHitsShowingProps
>({
  name: "AmountHitsShowing",
  props: {
    event: {},
  },
  computed: {
    amountShowing() {
      return this.$store.getters.amountShowing;
    },
    totalItems() {
      return this.$store.getters.totalItems;
    },
  },
  components: {},
});
